import React from "react";
import { Facebook, LinkedIn, Instagram } from "@material-ui/icons";
import styled from "styled-components";
import "../scss/social-network.scss";
import SocialCard from "./SocialCard";

const SocialContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const SocialNetworksContainer = () => {
  return (
    <SocialContainer>
      <SocialCard
        Icon={LinkedIn}
        url="https://www.linkedin.com/company/cartésia-junior"
        customStyle="linkedin"
      />
      <SocialCard
        Icon={Instagram}
        url="https://www.instagram.com/cartesia.junior/"
        customStyle="instagram"
      />
      <SocialCard
        Icon={Facebook}
        url="https://www.facebook.com/Cart%C3%A9sia-Junior-101792554957167"
        customStyle="fb"
      />
    </SocialContainer>
  );
};

export default SocialNetworksContainer;
